<template>
    <div class="basic-box">
        <van-nav-bar
                safe-area-inset-top
                fixed
                left-arrow
                @click-left="$router.back()"
                :title="$t('user.inviteFriends')"
        >
        </van-nav-bar>
        <div class="cont">
            <div class="nav">
                <div>{{ $t('lang.有你更精彩') }}</div>
            </div>
            <div class="title1">{{ $t('lang.携手同行') }}</div>
            <div class="title2">{{ $t('lang.邀请好友参与享受丰厚收益') }}</div>
            <div class="code">{{ $t('userSet.aa') }} {{ data.invitation_code }}</div>
            <div class="border">
                <div class="qrcode" id="qrcode"></div>
            </div>
            <van-button
                    class="btn"
                    block
                    color="linear-gradient(0deg, rgb(173, 134, 103) 0%, rgb(244, 228, 215) 100%)"
                    @click="copy()"
            >
                {{ $t('lang.邀请链接') }}:
                {{ $t('lang.点击复制') }}
            </van-button>
            <van-button
                    class="btn"
                    block
                    color="linear-gradient(0deg, rgb(173, 134, 103) 0%, rgb(244, 228, 215) 100%)"
                    @click="downloadIamge"
            >
                {{$t('lang.保存图片')}}
            </van-button>
        </div>
    </div>
</template>

<script>
import Qrcode from 'qrcodejs2';
import Fetch from '@/utils/fetch';

export default {
    name: "invite",
    data() {
        return {
            data: {},
            qrcodeData: {},
        }
    },
    created() {
        this.$parent.footer('', false)
        this.start();
        this.setQrcode();
    },
    methods: {
        start() {
            Fetch('/user/info').then((r) => {
                this.data = r.data;
            });
        },
        setQrcode() {
            this.$nextTick(() => {
                this.qrcodeData = new Qrcode('qrcode', {
                    width: 158,
                    height: 158,
                    text: 'asdasd',
                    colorDark: "#000",
                    colorLight: "#fff"
                })
            })
        },
        async copy() {
            let text = this.data.inviteUrl;
            let clipboard = navigator.clipboard || {
                writeText: (text) => {
                    let copyInput = document.createElement('input');
                    copyInput.value = text;
                    document.body.appendChild(copyInput);
                    copyInput.select();
                    document.execCommand('copy');
                    document.body.removeChild(copyInput);
                }
            }
            if (clipboard) {
                await clipboard.writeText(text);
                this.$toast({
                    background: "#07c160",
                    message: this.$t('invest_qrcode.copySucceeded'),
                });
            }
        },
        downloadIamge: function() {
            let imgsrc = this.qrcodeData._oDrawing._elImage.src;
            let image = new Image();
            image.setAttribute("crossOrigin", "anonymous");
            image.onload = function() {
                let canvas = document.createElement("canvas");
                canvas.width = image.width;
                canvas.height = image.height;
                let context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, image.width, image.height);
                let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
                let a = document.createElement("a"); // 生成一个a元素
                let event = new MouseEvent("click"); // 创建一个单击事件
                a.download =  "img"; // 设置图片名称没有设置则为默认
                a.href = url; // 将生成的URL设置为a.href属性
                a.dispatchEvent(event); // 触发a的单击事件
            };
            image.src = imgsrc;
        },
    }
}
</script>

<style scoped lang="less">
/deep/ .van-nav-bar {
  color: rgb(239, 216, 196);
  background-color: rgb(35, 29, 29);
}

/deep/ .van-nav-bar__title {
  color: rgb(239, 216, 196);
}

/deep/ .van-nav-bar .van-icon {
  color: rgb(239, 216, 196);
}

.basic-box {
  height: 100vh;
}

.cont {
  height: calc(100vh - 46px);
  margin-top: 46px;
  background: url("../../assets/img/in-bg.png") no-repeat;
  background-size: 100% 100%;

  .border {
    margin: 0 auto;
    margin-top: 20px;
    width: fit-content;
    padding: 10px;
    background-color: #FFFFFF;
  }

  .qrcode {
    width: 158px;
    height: 158px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btn {
    width: 80%;
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 8px;
    color: rgb(60, 44, 34) !important;
  }

  .nav {
    padding-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    font-family: Microsoft YaHei;
    font-weight: 700;
    color: #e1ccb9;
  }

  .title1 {
    margin-top: 20px;
    width: 100%;
    font-size: 14px;
    font-weight: 700;
    color: #e1ccb9;
    text-align: center;
    margin-bottom: 1.5625rem;
  }

  .title2 {
    width: 17.09375rem;
    padding: 0 1.40625rem;
    height: 2.5rem;
    border: 0.0625rem solid #FCDDC1;
    border-radius: 0.40625rem;
    margin: 0 auto;
    text-align: center;
    line-height: 2.5rem;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #e1ccb9;
  }

  .code {
    padding: 8px 6px;
    margin: 0 auto;
    width: 8rem;
    font-size: .8rem;
    text-align: center;
    border: 1px solid #FFFFFF;
    color: rgb(255, 255, 255);
    margin-top: 20px;
  }
}
</style>
